import React from "react";
import "./ToolTips.css";

export default function Tooltip({ message, x, y }) {
  return (
    <div
      className="tooltip-box"
      style={{ top: y, left: x }}
    >
      {message}
      <div className="tooltip-arrow"></div>
    </div>
  );
}
